import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './Pages/Dashboard';
import Layout from './components/Layout';
import Initiatepayout from './Pages/Initiatepayout';
import Invoice from './Pages/Invoice';
import Profile from './Pages/Profile';
import Reports from './Pages/Reports';
import UpdateIP from './Pages/UpdateIP';
import DeveloperTools from './Pages/DeveloperTools';
import Kyc from './Pages/Kyc';
import Payout from './Pages/Payout';
import Otp from './components/Otp';
import ForgotEmail from './components/ForgotEmail';
import Senderaccount from './Pages/SenderAccount';
import FundLoad from './Pages/FundHistory';
import Updateip from './Pages/UpdateIP';

function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/otp" element={<Otp />} />
          {/* <Route path="/forgot/password/email" element={<ForgotEmail />} /> */}
          {/* <Route path="/layout" element={<Layout />} /> */}
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
          <Route path="/Fundload" element={<Layout><FundLoad /></Layout>} />
          <Route path="/Payout" element={<Layout><Payout /></Layout>} />
          <Route path="/Initiatepayout" element={<Layout><Initiatepayout /></Layout>}/>
          <Route path="/DeveloperTools" element={<Layout><DeveloperTools /></Layout>}/>
          {/* <Route path="/Invoice" element={<Layout><Invoice /></Layout>}/> */}
          <Route path="/Profile" element={<Layout><Profile /></Layout>}/>
          <Route path="/udpateip" element={<Layout><Updateip /></Layout>}/>
          {/* <Route path="/Reports" element={<Layout><Reports /></Layout>}/> */}
          <Route path="/Kyc" element={<Layout><Kyc /></Layout>}/>
          {/* <Route path="/Initiatepayout/UpdateIP/:id" element={<Layout><UpdateIP /></Layout>}/>
          <Route path="/Initiatepayout/senderaccount/:id" element={<Layout><Senderaccount/></Layout>}/> */}
        </Routes>
    </BrowserRouter>
  );
}

export default App;
